import React, { createContext, useContext, useEffect, useState } from "react";
import { http } from "@/lib/api";

const AuthCtx = createContext({ user: null, loading: true, login: null, logout: null, register: null });

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await http.get("/auth/me");
        setUser(data);
      } catch (e) {
        setUser(null);
      } finally {
        setLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (email, password) => {
    const { data } = await http.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("wv_token", data.token);
    setUser(data);
    return data;
  };
  const register = async (payload) => {
    const { data } = await http.post("/auth/register", payload);
    // Pending accounts do NOT log in automatically — admin approval required
    if (data && data.pending) {
      return { pending: true, ...data };
    }
    if (data.token) localStorage.setItem("wv_token", data.token);
    setUser(data);
    return data;
  };
  const logout = async () => {
    try { await http.post("/auth/logout"); }
    catch (e) { console.error("logout request failed:", e); }
    localStorage.removeItem("wv_token");
    setUser(null);
  };
  return <AuthCtx.Provider value={{ user, loading, login, register, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
